import { render, staticRenderFns } from "./hardware_version.vue?vue&type=template&id=34c47d36"
import script from "./hardware_version.vue?vue&type=script&lang=js"
export * from "./hardware_version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports